import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealUserEntity } from '../../domain/entities/MealUserEntity'
import type { MealUserAdminDto } from '@/backend/market'

export class MealUserModel extends MealUserEntity {
  constructor(dataDto: MealUserAdminDto) {
    super()
    mapEntityProperties<MealUserEntity>(this, dataDto, {
      map: {
        companyUserId: dataDto.companyUserUserId,
        companyUserDisplayName: dataDto.companyUserUserDisplayName
      }
    })
  }
}
